import { render, staticRenderFns } from "./MyCourses.vue?vue&type=template&id=3ca7e894"
import script from "./MyCourses.vue?vue&type=script&lang=js"
export * from "./MyCourses.vue?vue&type=script&lang=js"
import style0 from "./MyCourses.vue?vue&type=style&index=0&id=3ca7e894&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports